import { Component, Inject } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { Direction } from '@angular/cdk/bidi';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Overlay } from '@angular/cdk/overlay';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { CLOSE, DAYS_NAMES, LINE_NOT_ACTIVE_ON_SELECTED_DAY, LINE_WILL_RETURN_ON_DAY } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { CalendarService } from 'src/app/modules/route-planner/services/calendar/calendar.service';
import { NextDayOfService } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/next-day-of-service.interface';

@Component({
    selector: 'app-route-not-active-pop-up',
    templateUrl: './route-not-active-pop-up.component.html',
    styleUrl: './route-not-active-pop-up.component.scss',
    standalone: false
})
export class RouteNotActivePopUpComponent extends PopUpComponent {

  direction: Direction
  closeText: string
  routeId: number
  lineNotActiveText: string
  lineWillReturnOnDayText: string
  nextDayOfService: NextDayOfService = null
  isLoading: boolean = true

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    @Inject(POPUP_DATA)
    public readonly data:  { routeId: number } ,
    private readonly languageService: LanguageService,
    private readonly calendarService: CalendarService,
  ) {
    super(routePlanningService, resizeService, overlay);
    this.routeId = data.routeId;
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.initializeMultiLanguageTexts()
    this.fetchNextDayOfService()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.closeText = CLOSE[language.language]
      this.lineNotActiveText = LINE_NOT_ACTIVE_ON_SELECTED_DAY[language.language]
      this.lineWillReturnOnDayText = LINE_WILL_RETURN_ON_DAY[language.language]
    })
  }

  fetchNextDayOfService() {
    this.isLoading = true
    this.calendarService.GetRouteNextDayOfService({
      routeId: this.routeId,
      day: new Date().toISOString(),
    }).subscribe({
      next: (res) => {
        this.nextDayOfService = res.data
        this.isLoading = false
      },
      error: () => {
        this.isLoading = false
      }
    })
  }

  getNextDayOfServiceText(): string {
    if (this.nextDayOfService) {
      const language = this.languageService.getSelectedLanguage().language
      return `${this.lineWillReturnOnDayText} ${DAYS_NAMES[language][this.nextDayOfService.dayOfService]} - ${this.nextDayOfService.dateOfServiceString}`
    }
    return ''
  }
}
